import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {NgOrelCardIpgService} from './ng-orel-card-ipg.service';

@Component({
  selector: 'lib-ng-orel-card-ipg',
  template: `
    <div *ngIf="this.ifShowPage">
      <iframe class='e2e-iframe-trusted-src holds-the-iframe' [src]="pageUrl"></iframe>
    </div>
  `,
  styleUrls: ['./ng-orel-card-ipg.component.css']
})
export class NgOrelCardIpgComponent implements OnInit {

  public ifShowPage: boolean;
  public session: string;
  private setStage: string;
  private pageUrl: any;
  configuration = {
    local: {
      gtUrl: 'https://orel.mpg/app',
    },
    dev: {
      gtUrl: 'https://testgateway.paymediasolutions.com',
    },
    prod: {
      gtUrl: 'https://gateway.orelpay.lk',
    }
  };

  constructor(private sanitizer: DomSanitizer, private cardIpgService: NgOrelCardIpgService) {
  }

  ngOnInit(): void {
    this.cardIpgService.showPage$.subscribe(lst => this.ifShowPage = lst);
    this.cardIpgService.getSession$.subscribe(st => {
      this.pageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.configuration[this.setStage].gtUrl + '/' + st);
    });
    this.cardIpgService.selectedStage$.subscribe(stg => this.setStage = stg);
  }

}
